import { basePath } from "./config";
import axios from "axios";

export function getInfoQrGafete( folio ) {
    const url = `${basePath}/acreditacion/infoQrGafete`;
    return axios.post(url, {folio: folio}, {});
}